module.exports = __webpack_public_path__ + "img/bachelor-ingenierie-et-gestion-industrielles.4c34922a.jpg";